import React, { useRef, useEffect } from "react";
import Select, { components } from "react-select";
import { CUSTOM_INPUT_PILL } from "../../../utils/enum";
import style from "./dropdown.module.scss";

const searchTypeCustomStyles = {
  control: (base, state) => ({
    ...base,
    minHeight: 38,
    width: "100%",
    backgroundColor: "#fff",
    borderRadius: "4px",
    fontSize: "14px",
    fontWeight: 600,
    textAlign: "left",
    border: "none",
    zIndex: 2,
    outline: state.isFocused ? "1px solid #6F08F1" : "1px solid #e4e7eb",
    "&:hover": {
      outline: "1px solid #6F08F1",
    },
  }),
  menu: (base) => ({
    ...base,
    fontSize: "14px",
    zIndex: 99,
  }),
  multiValue: (base) => ({
    ...base,
    fontWeight: "400",
  }),
  placeholder: (defaultStyles) => {
    return {
      ...defaultStyles,
      color: "darkgray",
      fontWeight: 400,
    };
  },
  MultiValueRemove: (defaultStyles) => ({
    ...defaultStyles,
    backgroundColor: "#E2D9FC",
    color: "#6F08F1",
  }),
  option: (base, { isDisabled, isFocused, isSelected, isHovered }) => ({
    ...base,
    backgroundColor: null,
    color: isDisabled ? null : isSelected ? "#1a1722" : isFocused ? "#1a1722" : null,
    cursor: "pointer !important",
    textAlign: "left",
  }),
};

const CustomDropdown = ({ options, onChangeHandler, item, index, parentData, placeholder, value, openInputHandler, closeInputHandler }) => {
  const divRef = useRef(null);

  useEffect(() => {
    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  });

  const ValueContainer = (props) => {
    let maxToShow = 2;
    var length = props.getValue().length;
    let displayChips = React.Children.toArray(props.children).slice(0, maxToShow);
    let shouldBadgeShow = length > maxToShow;
    let displayLength = length - maxToShow;
    return (
      <components.ValueContainer {...props}>
        {!props.selectProps.inputValue && displayChips}
        <div className={shouldBadgeShow ? style.select_input_count_badge_pill : ""}>{shouldBadgeShow && `+ ${displayLength}`}</div>
      </components.ValueContainer>
    );
  };

  const ParentOption = (props) => {
    return (
      <div onClick={(e) => e.stopPropagation()}>
        <components.Option {...props}>
          <div className="d-flex align-items-center justify-content-between">
            <div className="d-flex align-items-center">
              <input className="primary_checkbox" type="checkbox" checked={props.isSelected} />
              <label className="text-break m-0 ms-4">{props.label}</label>
            </div>
            {props?.data?.pill ? (
              <label style={{ background: props?.data?.pillColor ? props?.data?.pillColor : CUSTOM_INPUT_PILL }} className={style.select_input_pill}>
                {props.data.pill}
              </label>
            ) : (
              <></>
            )}
          </div>
        </components.Option>
      </div>
    );
  };

  const parentCustomComponents = {
    IndicatorSeparator: () => null,
    Option: ParentOption,
    ValueContainer: ValueContainer,
  };

  const handleClickOutside = (e) => {
    if (item.isOpen && !divRef.current.contains(e.target)) {
      closeInputHandler(item, index);
    }
  };

  return (
    <div
      onClick={(e) => {
        e.stopPropagation();
        openInputHandler(item, index);
      }}
      ref={divRef}
    >
      <Select
        options={options}
        styles={searchTypeCustomStyles}
        placeholder={placeholder}
        isMulti
        closeMenuOnSelect={false}
        isSearchable={true}
        hideSelectedOptions={false}
        menuIsOpen={item?.isOpen}
        // menuIsOpen={props.titleDropdownClose}
        value={value}
        components={parentCustomComponents}
        onChange={(value) => onChangeHandler(value, item, index, parentData)}
      />
    </div>
  );
};

export default CustomDropdown;
